export default __webpack_public_path__ + "static/media/job_offer16_s.e30c531a.jpg";